export default __webpack_public_path__ + "static/media/download2.63caa28b.jpg";